import React, { Component } from "react";
import { Link } from "react-router-dom";
import { AIVA_FEATURES, AIVA_INTEGRATIONS } from "../../../constants";

class Benefits extends Component {
  renderFeatures() {
    let features = AIVA_FEATURES.map(({ icon, title, description }) => {
      return (
        <div
          key={`av ${title}`}
          className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0"
        >
          <div className="aiva-feature-card anim_piece">
            <span className={`aiva-feature-icon fa ${icon}`}></span>
            <h5 className="aiva-feature-title">{title}</h5>
            <p className="aiva-feature-desc">{description}</p>
          </div>
        </div>
      );
    });

    return features;
  }

  renderIntegrations() {
    let integrations = AIVA_INTEGRATIONS.map((item) => {
      return (
        <span key={`int ${item}`} className="aiva-integrations-item">
          {item}
        </span>
      );
    });

    return integrations;
  }

  render() {
    return (
      <section id="aiva-features">
        <div className="container">
          <div className="row">
            <div className="col text-center">
              <h2 className="anim_piece">What AIVA Can Do</h2>
              <p className="aiva-features-subhead anim_piece">
                A brand-aligned assistant with agentic capabilities, built
                to converse, learn, integrate, and act.
              </p>
            </div>
          </div>

          <div className="row aiva-feature-row">{this.renderFeatures()}</div>

          <div className="row">
            <div className="col">
              <div className="aiva-integrations-line anim_piece">
                <span className="aiva-integrations-label">
                  Models &amp; Agent Integrations
                </span>
                <div className="aiva-integrations-list">
                  {this.renderIntegrations()}
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-5">
            <div className="col text-center">
              <Link
                to="/contact"
                className="btn btn-dark-green waves-effect anim_piece"
              >
                Interested? Let's Talk
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Benefits;
